import React from "react";
import BuildingMeasures from "@/pages/takeoff/context/project-measure/models/building-measures";
import FileRecord from "@/pages/takeoff/context/project-measure/models/file-record";
import FragmentRecord from "@/pages/takeoff/context/project-measure/models/fragment-record";
import Measure from "@/pages/takeoff/context/project-measure/models/measure";
import StoreyMeasures from "@/pages/takeoff/context/project-measure/models/storey-measures";

export type MeasureSelectionOrigin = "viewer" | "list";

export interface MeasureSelection {
    measures: Measure[];
    origin: MeasureSelectionOrigin;
}

export interface StoreyMeasuresContextProps {
    building: BuildingMeasures,
    storey: StoreyMeasures,
    measures: Measure[],
    measuresRef: React.MutableRefObject<Measure[]>,
    tempMeasures: Measure[],

    selectedMeasures: MeasureSelection | undefined;
    setSelectedMeasures: React.Dispatch<React.SetStateAction<MeasureSelection | undefined>>;
    handleGeometriesSelected: (geometries: string[]) => void;
    
    isSaving: boolean,
    isDirty: boolean,

    storeyFilesRecord: FileRecord[],
    storeyFragsRecord: FragmentRecord[],

    addMeasure: (measure: Measure) => void,
    editMeasure: (measureId: string, measure: Measure) => void,
    removeMeasure: (measureId: string) => void,
    saveMeasures: (measuresBuffer: ArrayBuffer) => Promise<boolean>

    updateProjectData: () => void
}

export const StoreyMeasuresContext = React.createContext<StoreyMeasuresContextProps | undefined>(undefined);